import { render, staticRenderFns } from "./AdminNews.vue?vue&type=template&id=02163404&"
import script from "./AdminNews.vue?vue&type=script&lang=js&"
export * from "./AdminNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports